
define('text!templates/app/payment/payment.html',[],function () { return '<div id="payment-modal">\n</div>\n';});

